import { atom } from 'recoil';

export const concept = atom({
  key: 'concept',
  default: undefined,
});
